import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/rule-close.png'
import _imports_1 from '@/assets/img/rule.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "rule-cover" }, null, -1)
const _hoisted_2 = { class: "rule-wrapper" }
const _hoisted_3 = { class: "rule-content" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          class: "close",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeClick && _ctx.closeClick(...args)))
        }, [
          _hoisted_4
        ]),
        _hoisted_5
      ])
    ])
  ], 64))
}